import { v4 as uuid } from 'uuid';
import { UsersApi } from '../../Utils/apis';
import { iBinderFetch } from '../../Utils/iBinderFetch';
import { ImpersonateTenant } from '../../Utils/impersonateTenant';

const id = uuid();
const githubUrl = `https://github.com/iBinder/admins-ui/tree/main/${__filename}`;

// *****************************************************************************
// START - The part between START and END is the part that is added to the file.
// *****************************************************************************
const name = '<NAME OF THE OPERATION>';
const description = '<DESCRIPTION OF THE OPERATION>';

// The input model
export interface InputInterface {
  TEMPLATE_PROP?: string;
}

// The sample input, prefilled in the editor
const sample: InputInterface = {
  TEMPLATE_PROP: '<PREFILLED TEMPLATE PROP DATA>'
}; //Sani

// The actual function called with the input
const fn =
  ({ tenantId }) =>
  async ({ TEMPLATE_PROP: userId }: InputInterface) => {
    const tenantFetch = iBinderFetch({ tenantId });

    // <INSERT YOUR CODE HERE>

    return JSON.stringify({
      FilipsUSer: { TEMPLATE_RESPONSE_PROP: '>TEMPLATE_RESPONSE_VALUE>' }
    });
  };

// *****************************************************************************
// END - The part between START and END is the part that is added to the file.
// *****************************************************************************

export default {
  onSubmit:
    ({ tenantId }) =>
    async (jsonData) =>
      await fn({ tenantId })(jsonData),
  sample,
  id,
  name,
  description,
  githubUrl
};
